export default __webpack_public_path__ + "static/bestie-1-f8ef8b82fd96ad63cb20cb897165e303.webp";